import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAnalytics } from '../contexts/AnalyticsContext';

const { FiExternalLink } = FiIcons;

const TopPages = () => {
  const { analyticsData } = useAnalytics();

  const getTopPages = () => {
    const pageStats = {};
    
    analyticsData.pageViews.forEach(pv => {
      const page = pv.page || '/';
      if (!pageStats[page]) {
        pageStats[page] = {
          page,
          views: 0,
          uniqueVisitors: new Set()
        };
      }
      pageStats[page].views++;
      pageStats[page].uniqueVisitors.add(pv.visitorId);
    });

    return Object.values(pageStats)
      .map(stat => ({
        ...stat,
        uniqueVisitors: stat.uniqueVisitors.size
      }))
      .sort((a, b) => b.views - a.views)
      .slice(0, 10);
  };

  const topPages = getTopPages();

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Top Pages</h3>
      
      <div className="space-y-4">
        {topPages.length === 0 ? (
          <p className="text-gray-500 text-center py-8">No page data available</p>
        ) : (
          topPages.map((page, index) => (
            <motion.div
              key={page.page}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors"
            >
              <div className="flex-1">
                <div className="flex items-center">
                  <span className="text-sm font-medium text-gray-900">
                    {page.page}
                  </span>
                  <SafeIcon icon={FiExternalLink} className="ml-2 h-3 w-3 text-gray-400" />
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {page.uniqueVisitors} unique visitors
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">
                  {page.views.toLocaleString()}
                </p>
                <p className="text-xs text-gray-500">views</p>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  );
};

export default TopPages;